import React from "react";
import '../css/booking.css';


function About() {

    return (

        <section id='Booking'>

            <div className="container booking__container">

                <h1>Booking</h1>


                <h2>Coming Soon !!</h2>
                
                
            </div>

        </section>

    );

}

export default About;